<template>
  <div v-if="maxAvailableExecutions" class="d-flex justify-between align-center">
    <div class="d-flex align-center flex-grow-1">
      <vs-button
        small
        type="tertiary"
        label="View Request"
        icon="mdi-arrow-right"
        class="request-button"
        right-icon
        :to="requestSideSheetTo"
        :disabled="!jobRequestId"
      />
    </div>
    <div class="d-flex align-center flex-grow-1 justify-center mr-8">
      <vs-text type="header" aria-label="Job Number" class="mr-2">Job</vs-text>
      <vs-heading type="subhead">{{ currentJobNumber }} of {{ maxAvailableExecutions }}</vs-heading>
    </div>
    <div class="d-flex align-center justify-end flex-grow-1">
      <vs-text type="header" aria-label="Remaining Jobs" class="mr-2">{{
        remainingExecutionsLabel
      }}</vs-text>
      <vs-heading v-if="remainingExecutions > 0" type="subhead" aria-label="Remaining Jobs Count">
        {{ remainingExecutions }}
      </vs-heading>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router/composables'
import { useGetJobRequestQuery } from '@/api/jobs'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsText from '@/components/vision/VsText.vue'
import VsButton from '@/components/vision/VsButton.vue'

interface Props {
  jobId?: string
  jobRequestId?: string | null
  enableRequestSidesheet: boolean
}

const props = withDefaults(defineProps<Props>(), {
  jobId: undefined,
  jobRequestId: undefined,
})

const route = useRoute()

const jobRequestIdRef = computed(() => props.jobRequestId ?? '')
const { data: jobRequest } = useGetJobRequestQuery(jobRequestIdRef)
const maxAvailableExecutions = computed(() => jobRequest.value?.maxExecutions)
const remainingExecutions = computed(() =>
  jobRequest.value ? jobRequest.value.maxExecutions - jobRequest.value.jobIds.length : 0,
)
const currentJobNumber = computed(
  () => (jobRequest.value?.jobIds.findIndex((id) => id === props.jobId) ?? -1) + 1,
)
const remainingExecutionsLabel = computed(() =>
  remainingExecutions.value > 0 ? 'Remaining' : 'Trips Complete',
)

const requestSideSheetUrl = computed(() => {
  const routePrefix = route.name?.split('-')[0]
  return `${routePrefix}-job-request`
})

const requestSideSheetTo = computed(() => {
  if (!props.jobRequestId) return undefined

  return {
    name: requestSideSheetUrl.value,
    params: { requestId: props.jobRequestId },
  }
})
</script>

<style scoped>
.request-button {
  margin-left: -10px;
}
</style>
